import { READ_ONLY_MODE } from "Areas/Documents/documentDetails/types/readOnlyMode";
import { ButtonWithTooltip } from "Components/button";
import { themeVariables } from "Components/theme";
import YesNoConfirmation from "Components/yesNoConfirmation";
import compact from "lodash/compact";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import React from "react";
import { NAV_ITEM_DISABLED_CLASS_NAME, SidebarMenuItem } from "../../Common";
import { MAX_COUNT_OF_TRANSFORMS_WITHOUT_CONFIRMATION } from "../constants";
import locale from "./buildScriptSidebarItems.locale";
export const buildScriptKey = (sId) => `script_${sId}`;
export const buildScriptMethodKey = (mId) => `scriptMethod_${mId}`;
const confirmationPosition = {
    my: "left top",
    at: {
        x: "right",
        y: "top"
    }
};
export default (data, selectedNodesSource, readOnlyMode, onRunClick, renderMenu) => isEmpty(data)
    ? []
    : map(data, (item) => {
        const e = new SidebarMenuItem(buildScriptKey(item.Id), item.Name, undefined, undefined, item, map(item.Methods, m => {
            const methodMenuItem = new SidebarMenuItem(buildScriptMethodKey(m.Id), `${m.GroupName} / ${m.Name}`);
            if (readOnlyMode !== READ_ONLY_MODE.READ_WRITE) {
                methodMenuItem.className = NAV_ITEM_DISABLED_CLASS_NAME;
            }
            return methodMenuItem;
        }));
        if (readOnlyMode !== READ_ONLY_MODE.READ_WRITE) {
            e.className = NAV_ITEM_DISABLED_CLASS_NAME;
        }
        else if (onRunClick || renderMenu) {
            let runScriptElement;
            if (onRunClick && selectedNodesSource && item.Methods) {
                const runCallback = () => {
                    onRunClick && onRunClick(item, selectedNodesSource);
                };
                const countOfTransforms = selectedNodesSource.length * item.Methods.length;
                const needConfirm = countOfTransforms > MAX_COUNT_OF_TRANSFORMS_WITHOUT_CONFIRMATION;
                const runScriptButton = (React.createElement(ButtonWithTooltip, { key: "play", className: "p-0 no-default-colors no-border flex-box-centered-content", wrapperClassName: "animate-hover-color flex-box-centered-content", popoverContent: locale.RUN_SCRIPT, onClick: !needConfirm ? runCallback : undefined },
                    React.createElement("i", { className: "icon-play font-h4 flex-box-centered-content" })));
                runScriptElement = needConfirm ? (React.createElement(YesNoConfirmation, { key: "play", showEvent: "dxclick", onConfirm: runCallback, title: locale.getConfirmRunText(countOfTransforms), zIndex: parseInt(themeVariables["zindex-pageheader-menu"]) + 2, position: confirmationPosition }, runScriptButton)) : (runScriptButton);
            }
            e.actionElements = compact([renderMenu ? renderMenu(item) : null, runScriptElement]);
        }
        return e;
    });
